var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "infinite-scroll", on: { click: _vm.onClick } },
    [
      _vm._t(
        "default",
        [
          _vm.state === "loading"
            ? [_vm._v("\n      Loading...\n    ")]
            : _vm.state === "empty"
            ? [_vm._v("\n      Empty\n    ")]
            : _vm.state === "end"
            ? [_vm._v("\n      End\n    ")]
            : _vm.state === "error"
            ? [_vm._v("\n      An error occurred. Click to retry.\n    ")]
            : _vm.state === "standby" && _vm.auto !== "in-advance"
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.auto
                        ? "Scroll " + _vm.direction + " to load more"
                        : "Click to load more"
                    ) +
                    "\n    "
                )
              ]
            : _vm._e()
        ],
        {
          state: _vm.state,
          error: _vm.error,
          auto: _vm.auto,
          direction: _vm.direction
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }